import { LinkStyleType, LinkType, StyledLink } from '../../../components'

export interface MainContentSectionLinkProps {
  id: string
  important?: boolean
  lineText: string
  lineUrl: string
  type: LinkType
}

export const MainContentSectionLink = ({
  id,
  important,
  lineText,
  lineUrl,
  type = LinkType.BASIC
}: MainContentSectionLinkProps) => {
  const commonLinkProps = {
    id,
    linkStyleType: important ? LinkStyleType.IMPORTANT : LinkStyleType.NORMAL
  }

  return (
    <>
      {type === LinkType.ROUTED ? (
        <StyledLink type={type} to={lineUrl} {...commonLinkProps}>
          {lineText}
        </StyledLink>
      ) : (
        <StyledLink
          type={LinkType.BASIC}
          href={lineUrl}
          rel="noreferrer"
          target="blank"
          {...commonLinkProps}
        >
          {lineText}
        </StyledLink>
      )}
    </>
  )
}
